import * as t from 'typegate';
import { conditions, query } from './conditions/conditions';
export var SetValueEffectSpecialValue;
(function (SetValueEffectSpecialValue) {
    SetValueEffectSpecialValue["newId"] = "{{new_id}}";
})(SetValueEffectSpecialValue || (SetValueEffectSpecialValue = {}));
export const effectValue = t.union(t.string, t.boolean, t.number, t.lazy(() => query), t.tsEnum(SetValueEffectSpecialValue), t.undefined);
export const setValueEffect = t
    .object(t.property('at', t.string), t.property('value', effectValue), t.optionalProperty('triggerIf', t.lazy(() => conditions)), t.optionalProperty('newAnswerMustMatch', t.unknown))
    .setTypeName('SetValueEffect');
export const engineEffects = t
    .object(t.optionalProperty('beforeValueUpdate', t.array(setValueEffect)), t.optionalProperty('afterValueUpdate', t.array(setValueEffect)))
    .setTypeName('EngineEffects');
